import { render } from "./ContactForm.vue?vue&type=template&id=e10b2916&ts=true"
import script from "./ContactForm.vue?vue&type=script&lang=ts"
export * from "./ContactForm.vue?vue&type=script&lang=ts"

import "./ContactForm.vue?vue&type=style&index=0&id=e10b2916&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__